import { Fragment, useMemo } from 'react';
import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import { useLayoutSelector } from '../../redux';
import { JobDefinitions } from '../../views/Jobs/Jobs.model';
import { About } from '../About';
import { Main } from '../Main';
import { SelectVehicle } from '../SelectVehicle';
import { JobsStage } from './JobsPanel.model';
import {
	StyledContainer,
	StyledDecBgBottom,
	StyledDecBgTop,
	StyledHead,
	StyledLogoContainer,
} from './JobsPanel.styled';

const JobsPanel = () => {
	const jobId = useObservable(rage.jobs.getOpenedJobId());
	const jobConfig = useMemo(
		() => (jobId ? JobDefinitions[jobId] : null),
		[jobId],
	);
	const activeStage = useLayoutSelector((state) => state.jobs.activeStage);

	useInputAction(InputAction.CommonMenuClose, () => rage.jobs.exitMenu());

	if (!jobConfig) {
		return null;
	}

	return (
		<StyledContainer>
			<StyledDecBgTop />
			<StyledDecBgBottom />
			<StyledHead>
				<StyledLogoContainer>
					<img src={jobConfig?.logo} />
					<Text style={{ color: '#FFFFFF', fontSize: '16px', opacity: 0.5 }}>
						{jobConfig.title.split('\n').map((str, index) => (
							<Fragment key={`panelTitle#${index}`}>
								{str}
								<br />
							</Fragment>
						))}
					</Text>
				</StyledLogoContainer>
				<CloseButton
					height={ButtonHeight.Height40}
					color={ButtonColors.Default}
					iconSize={14}
					onClick={() => rage.jobs.exitMenu()}
				/>
			</StyledHead>
			{activeStage === JobsStage.MAIN && <Main />}
			{activeStage === JobsStage.ABOUT && <About />}
			{activeStage === JobsStage.SELECT_VEHICLE && <SelectVehicle />}
		</StyledContainer>
	);
};

export { JobsPanel };
